/* eslint-disable react/no-multi-comp */
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { stopSubmit } from 'redux-form'
import { Helmet } from 'react-helmet-async'
import { userActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import MyAccountForm from '../../components/Form/MyAccountForm/MyAccountForm'
import ConnectToSteam from './ConnectToSteam/ConnectToSteam'
import DeactivateAccountSection from './DeactivateAccountSection/DeactivateAccountSection'
import ChangePassword from './ChangePassword/ChangePassword'
import Loader from '../../components/Loader/Loader'
import { currentUser } from '../../redux/reducers/user.reducers'
import './MyAccount.scss'

const MyAccount = ({ update, getSessionUser, user, deactivate, clearFormError }) => {
  const updateUserInformation = ({ id, firstname, lastname, language }) => {
    if (
      user.user_detail.firstname === firstname &&
      user.user_detail.lastname === lastname &&
      user.user_detail.language === language
    )
      return false
    return update({ id, firstname, lastname, language }).then(() => {
      clearFormError()
      getSessionUser()
    })
  }

  const renderForm = () => {
    if (!user) return <Loader />
    return (
      <>
        <h4 className="mt-4">
          <FormattedMessage id="page.myAccountPage.subTitle.subHeroTitle" />
        </h4>
        <p>
          <FormattedMessage id="page.myAccountPage.subTitle.description" />
        </p>
        <p>
          <FormattedMessage id="page.myAccountPage.subTitle.note" />
        </p>
        <div className="row justify-content-center pb-4">
          <div className="col-md-8 col-xl-6">
            <MyAccountForm enableReinitialize onSubmit={updateUserInformation} />
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="container mt-5 mb-5 my-account-page" aria-labelledby="my-account-title">
      <Helmet>
        <title>My Account</title>
        <meta name="description" content="your description" />
      </Helmet>
      <h1 className="page-title" id="my-account-title">
        <FormattedMessage
          id="page.myAccountPage.title.heroTitle"
          values={{ FirstName: user.firstname }}
        />
      </h1>
      <h4>
        <FormattedMessage id="page.myAccountPage.title.description" />
      </h4>
      <div className="hr" />
      {renderForm()}
      <div className="hr" />
      <ChangePassword />
      <div className="hr" />
      <ConnectToSteam />
      <div className="hr" />
      <DeactivateAccountSection user={user} onDeactivate={deactivate} />
    </div>
  )
}

const mapStateToProps = state => ({
  user: currentUser(state),
})

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(userActions, dispatch),
  clearFormError: () => dispatch(stopSubmit('myAccount', {})),
})

export default connect(mapStateToProps, mapDispatchToProps)(MyAccount)
